export const CHANGE_DATE = 'LAYOUT/CHANGE_DATE';
export const CLEAR_DATE = 'LAYOUT/CLEAR_DATE';
